module.exports = __webpack_public_path__ + "static/media/test22.e5f7fc1d.jpeg";